// eslint-disable-next-line unicode-bom
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AccountDetails from "./AccountDetails";
import ChangePassword from "./ChangePassword";
import Orders from "./Orders";
import { useParams } from "react-router-dom";
import { loadStorage } from "../../Utils/Utils";
import { logOut } from "../../store/actions/action";
import { useDispatch } from "react-redux";
import AllOrders from "./AllOrders";
import AllUsers from "./AllUsers";
import AddProduct from "./AddProduct";
import ManageProducts from "./ManageProducts";
import Wishlist from "./Wishlist";
import Addresses from "./Addresses";
import ManagePincodes from "./ManagePincodes";

function Account() {
    const { target } = useParams();
    const [label, setLabel] = useState('');
    const dispatch = useDispatch();
    const userData = useSelector((store) => store.user.data) || loadStorage("user");
    const navigate = useNavigate();
    const onClickHome = (e) => {
        e.preventDefault();
        navigate('/');
    }
    const handlePathChange = (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(`/account/${e.currentTarget.id}`);
    };

    const onClickLogout = () => {
        dispatch(logOut());
        navigate('/');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const NavigateToTab = useMemo(() => {
        if (!userData) return null;
        switch (target) {
            case 'accountDetails': {
                setLabel('Account');
                return <AccountDetails />
            }
            case 'changePassword': {
                setLabel('Password');
                return <ChangePassword />
            }
            case 'myOrders': {
                setLabel('Orders');
                return <Orders userId={userData.id} />
            }
            case 'allOrders': {
                setLabel('Manage Orders');
                return <AllOrders userId={userData.id} isAdmin = {userData.isAdmin}/>
            }
            case 'allUsers': {
                setLabel('All Users');
                return <AllUsers userId={userData.id} />
            }
            case 'addProduct': {
                setLabel('Add Product');
                return <AddProduct userId={userData.id}/>
            }
            case 'manageProducts': {
                setLabel('Manage Products');
                return <ManageProducts userId={userData.id}/>
            }
            case 'wishlist': {
                setLabel('Wishlist');
                return <Wishlist />
            }
            case 'addresses': {
                setLabel('Saved Addresses');
                return <Addresses />
            }
            case 'managePincodes': {
                setLabel('Manage Pincodes');
                return <ManagePincodes />
            }
            default: return null;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target])

    return (
        <main>
            <div className="accounnt_header">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-auto col-12 order-md-2">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <a href="#" className="text-nowrap classLink" onClick={(e) => onClickHome(e)}><i className="fa fa-home mr-2"></i>Home</a>
                                    </li>
                                    <li className="breadcrumb-item text-nowrap active" aria-current="page">{label}</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="order-md-1 text-center text-md-left col-lg col-12">
                            <h1 style={{ 'float': 'left' }} className="h3 mb-0">{label}</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div className="accounnt_body">
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-lg-4 col-md-4 col-12">
                            <nav className="navbar navbar-expand-md mb-4 mb-lg-0 sidenav">
                                <a href="#" className="d-xl-none d-lg-none d-md-none text-inherit fw-bold" >Sidebar Menu</a>
                                <button className="navbar-toggler d-md-none rounded bg-primary text-light" type="button"
                                    data-toggle="collapse" data-target="#sidenav" aria-controls="sidenav"
                                    aria-expanded="false" aria-label="Toggle navigation">
                                    <span className="ti-menu"></span>
                                </button>
                                <div className="collapse navbar-collapse" id="sidenav">
                                    <div className="navbar-nav flex-column">
                                        <div className="border-bottom">
                                            <div className="m-4">
                                                <div className="row no-gutters align-items-center">
                                                    <div className="col-auto">
                                                        <div className="avater btn-soft-primary">DS</div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <h6 className="d-block font-weight-bold mb-0">{`${userData?.firstName ?? ''} ${userData?.lastName ?? ''}`}</h6>
                                                        <small className="text-muted">{userData?.email ?? ''}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <ul className="list-unstyled mb-0">
                                            <li className="nav-item active" id="accountDetails" onClick={(e) => handlePathChange(e)}>
                                                <a href="#" className="nav-link"  ><i className="fa fa-user"></i> My
                                                    Account</a>
                                            </li>
                                            <li className="nav-item" id="changePassword" onClick={(e) => handlePathChange(e)}>
                                                <a href="#" className="nav-link" ><i className="fa fa-lock"></i>
                                                    Password</a>
                                            </li>

                                            <li className="nav-item" id="myOrders" onClick={(e) => handlePathChange(e)}>
                                                <a href="#" className="nav-link"  ><i className="fa fa-shopping-cart"></i>
                                                    Orders</a>
                                            </li>
                                            <li className="nav-item" id="wishlist" onClick={(e) => handlePathChange(e)}>
                                                <a href="#" className="nav-link"><i className="fa fa-heart-o"></i>
                                                    Wishlist</a>
                                            </li>
                                            <li className="nav-item" id="addresses" onClick={(e) => handlePathChange(e)}>
                                                <a href="#" className="nav-link"><i className="fa fa-map-marker"></i>
                                                    Addresses</a>
                                            </li>
                                            {userData?.isAdmin &&
                                                <div>
                                                    <li className="nav-item" id="allOrders" onClick={(e) => handlePathChange(e)}>
                                                        <a href="#" className="nav-link"  ><i className="fa fa-shopping-cart"></i>
                                                            Manage Orders</a>
                                                    </li>
                                                    <li className="nav-item" id="allUsers" onClick={(e) => handlePathChange(e)}>
                                                        <a href="#" className="nav-link"  ><i className="fa fa-user"></i>
                                                            All Users</a>
                                                    </li>
                                                    <li className="nav-item" id="addProduct" onClick={(e) => handlePathChange(e)}>
                                                        <a href="#" className="nav-link"><i className="fa fa-plus-circle"></i>
                                                            Add Product</a>
                                                    </li>
                                                    <li className="nav-item" id="manageProducts" onClick={(e) => handlePathChange(e)}>
                                                        <a href="#" className="nav-link"><i className="fa fa-list"></i>
                                                            Manage Products</a>
                                                    </li>
                                                    <li className="nav-item" id="managePincodes" onClick={(e) => handlePathChange(e)}>
                                                        <a href="#" className="nav-link"><i className="fa fa-map-pin"></i>
                                                            Manage Pincodes</a>
                                                    </li>
                                                </div>}
                                            <li className="nav-item">
                                                <a href="#" className="nav-link" onClick={(e) => onClickLogout(e)}><i className="fa fa-sign-out"></i> Logout</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                        </div>
                        {NavigateToTab}
                    </div>
                </div>
            </div>
        </main>
    );
}
export default Account;
